import { Box, Link, VisuallyHidden } from "@simplybusiness/mobius";
import type { LogoProps } from "./types";

export const Logo = ({ poweredBySb, url }: LogoProps) => {
  if (!poweredBySb && url) {
    return (
      <Link href={url} className="mobius-header__logo">
        <VisuallyHidden>Simply Business homepage</VisuallyHidden>
      </Link>
    );
  }

  return <Box className="mobius-header__logo" />;
};
